import { render, staticRenderFns } from "./CarrierAreaFormModal.vue?vue&type=template&id=2424328a&scoped=true&"
import script from "./CarrierAreaFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierAreaFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424328a",
  null
  
)

export default component.exports